<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioTransferenciaTitular" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioTransferenciaTitular.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioTransferenciaTitular.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>CPF</mat-label>
                            <input matInput value="CPF" class="form-control" id="cpf" trim="blur" name="cpf"
                                formControlName="cpf" maxlength="14" trim="blur" nccCpfCnpjMask required>
                            <mat-error *ngIf="formularioTransferenciaTitular.controls.cpf.errors">
                                O campo CPF está inválido.
                            </mat-error>
                            <mat-error *ngIf="formularioTransferenciaTitular.controls.cpf.hasError('required')">
                                O campo CPF é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Data Nasc.</mat-label>
                            <input matInput [matDatepicker]="dataNascimentoDP" formControlName="dataNascimento"
                                id="dataNascimento" name="dataNascimento">
                            <mat-datepicker-toggle matSuffix [for]="dataNascimentoDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataNascimentoDP></mat-datepicker>

                            <mat-error
                                *ngIf="formularioTransferenciaTitular.controls.dataNascimento.hasError('required')">
                                O campo Data Nasc. é obrigatório.
                            </mat-error>

                            <mat-error
                                *ngIf="formularioTransferenciaTitular.controls.dataNascimento.hasError('invalidDate')">
                                O campo Data Nasc. está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Fone Residencial</mat-label>
                            <input matInput value="Fone Residencial" class="form-control" id="foneResidencial"
                                name="foneResidencial" phoneMask [maskInputId]="'foneResidencial'"
                                [preValue]="formularioTransferenciaTitular.value.foneResidencial"
                                [phoneControl]="formularioTransferenciaTitular.controls['foneResidencial']"
                                formControlName="foneResidencial" minlength="14" maxlength="16">
                            <mat-error *ngIf="formularioTransferenciaTitular.controls.foneResidencial.errors">
                                O campo Fone Residencial está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Núm. Celular</mat-label>
                            <input matInput value="Núm. Celular" class="form-control" id="foneCelular"
                                name="foneCelular" phoneMask [maskInputId]="'foneCelular'"
                                [preValue]="formularioTransferenciaTitular.value.foneCelular"
                                [phoneControl]="formularioTransferenciaTitular.controls['foneCelular']"
                                formControlName="foneCelular" minlength="14" maxlength="16">
                            <mat-error *ngIf="formularioTransferenciaTitular.controls.foneCelular.errors">
                                O campo Núm. Celular está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioTransferenciaTitular.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>